<script setup lang="ts">
type placementTypes =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'left'
  | 'left-start'
  | 'left-end'

const { trigger = 'hover' } = defineProps<{
  title?: string
  text?: StoryBlokRichText
  tooltipText?: string
  placement?: placementTypes
  persistent?: boolean
  trigger?: string
}>()
const popover = ref()
function close() {
  popover.value.hide()
  setTimeout(() => popover.value.hide(), 20)
}
</script>

<template>
  <ElPopover
    ref="popover"
    :placement="placement"
    :trigger="trigger"
    width="auto"
  >
    <div class="w-fit max-w-210px break-normal relative rounded-xl">
      <div class="flex gap-2 flow-col justify-between items-center text-left">
        <span class="headline-5 text-secondary">{{ title }}</span>
        <AppIcon
          size="12" icon="far-times"
          class="inline-flex justify-self-end text-secondary cursor-pointer p-10px"
          :class="[persistent ? 'md:visible' : 'md:hidden']" @click="close"
        />
      </div>
      <slot>
        <StoryblokRichText v-if="text" class="text-sm text-left text-secondary" :document="text" />
      </slot>
    </div>
    <template #reference>
      <slot name="tooltipText">
        <div class="flex items-center gap-1 text-primary hover:text-hover transition-colors duration-300 select-none">
          <AppIcon :size="13" icon="far-info-circle" class="mb-px" />
          <span v-if="tooltipText"> {{ tooltipText }}</span>
        </div>
      </slot>
    </template>
  </ElPopover>
</template>

<style>
.richtext-tooltip__margin hr {
    @apply !my-2;
  }
</style>
